import type { Event } from '@mr-website/schemas';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';
import { CalendarPlus } from 'lucide-react';
import { buildGoogleUrl, buildIcsDataUrl, buildOutlookUrl } from './utils';

interface AddToCalendarProps {
  event: Event;
}

export function AddToCalendar({ event }: AddToCalendarProps) {
  return (
    <Popover>
      <PopoverTrigger
        className="mt-2 inline-flex items-center gap-1.5 text-sm font-medium transition-opacity hover:opacity-70"
        style={{ color: 'var(--color-mr-teal)' }}
      >
        <CalendarPlus className="size-3.5" aria-hidden />
        Add to Calendar
      </PopoverTrigger>
      <PopoverContent align="start" className="w-48 p-1">
        <a
          href={buildGoogleUrl(event)}
          target="_blank"
          rel="noopener noreferrer"
          className="flex w-full items-center gap-2 rounded-md px-3 py-2 text-sm text-foreground transition-colors hover:bg-muted"
        >
          Google Calendar
        </a>
        <a
          href={buildOutlookUrl(event)}
          target="_blank"
          rel="noopener noreferrer"
          className="flex w-full items-center gap-2 rounded-md px-3 py-2 text-sm text-foreground transition-colors hover:bg-muted"
        >
          Outlook
        </a>
        <a
          href={buildIcsDataUrl(event)}
          download={`${event.name.replace(/\s+/g, '-')}.ics`}
          className="flex w-full items-center gap-2 rounded-md px-3 py-2 text-sm text-foreground transition-colors hover:bg-muted"
        >
          Apple Calendar
        </a>
      </PopoverContent>
    </Popover>
  );
}
